import { DescriptionText, ErrorMessage } from '@components/ErrorMessage';
import { cadExportInstructions } from '@constants/URLs';
import { faCloudExclamation, faFileCad } from '@fortawesome/pro-light-svg-icons';
import { FooterAction } from '@pages/CreateNewProductPage/styles';
import { Trans, useTranslation } from 'react-i18next';

interface UploadFailedProps {
  isFailedUpload?: boolean;
  filename: string;
  productName: string;
  onConfirm: () => void;
}

export function UploadFailed({ isFailedUpload, filename, productName, onConfirm }: Readonly<UploadFailedProps>) {
  const { t } = useTranslation('createProduct');

  const { icon, header, description, showKnowledgeBase } = isFailedUpload
    ? {
        icon: faCloudExclamation,
        header: t('errorUploadingCadHeader', { filename }),
        description: t('errorUploadingCadBody'),
        showKnowledgeBase: false,
      }
    : {
        icon: faFileCad,
        header: t('errorCadNoAssembliesHeader', { productName }),
        description: t('errorCadNoAssembliesBody'),
        showKnowledgeBase: true,
      };

  return (
    <ErrorMessage icon={icon} header={header}>
      <DescriptionText>{description}</DescriptionText>
      {showKnowledgeBase && (
        <>
          <DescriptionText>
            <Trans
              ns="createProduct"
              i18nKey="checkKnowledgeBaseExtra"
              components={{
                link: (
                  <a href={cadExportInstructions} target="_blank" rel="noreferrer">
                    {t('knowledgeBase')}
                  </a>
                ),
              }}
            />
          </DescriptionText>
          <DescriptionText>{t('tryUploadingAgain')}</DescriptionText>
        </>
      )}
      <FooterAction size="large" variant="text" onClick={() => onConfirm()}>
        {t('retryUpload')}
      </FooterAction>
    </ErrorMessage>
  );
}
